<template>
    <div class="t-container article">
      <div style="text-align: center; font-size: 35px; color: rgb(199 0 11); font-weight: 600; padding-top: 20px;"><span>{{ $i18n.t(`aboutHWT.six.content1`) }}</span></div>
      <p class="text article-content">{{ $i18n.t(`aboutHWT.six.content2`) }}</p>
      <ul>
        <li><p class="text article-content">{{ $i18n.t(`aboutHWT.six.content3`) }}</p></li>
        <li><p class="text article-content">{{ $i18n.t(`aboutHWT.six.content4`) }}</p></li>
        <li><p class="text article-content">{{ $i18n.t(`aboutHWT.six.content5`) }}</p></li>
        <li><p class="text article-content">{{ $i18n.t(`aboutHWT.six.content6`) }}</p></li>
        <li><p class="text article-content">{{ $i18n.t(`aboutHWT.six.content7`) }}</p></li>
        <li><p class="text article-content">{{ $i18n.t(`aboutHWT.six.content8`) }}</p></li>
        <li><p class="text article-content">{{ $i18n.t(`aboutHWT.six.content9`) }}</p></li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
  name: 'CultureAndValue',
  data() {
      return {}
  }
  }
  </script>
  
  <style lang="less" scoped>
  li {
    list-style: disc;
  }
  .text {
      margin-top: 30px;
      font-size: 16px;
      font-weight: 500;
  }
  .article {
      padding: 0 24px 16px;
      padding-bottom: 150px;
  
      .article-title {
      font-size: 40px;
      font-weight: 400;
      color: #000000;
      text-align: center;
      padding: 50px 0 40px;
      span {
          // border-bottom: 2px solid rgb(199 0 11);
          display: block;
          font-size: 28px;
          font-weight: 600;
      }
      }
  
      .article-content {
      font-size: 20px;
      font-weight: 400;
      color: #333333;
      line-height: 2.0;
      }
  }
  </style>